import React from "react";

interface ErrorDisplayProps {
  error: string | null;
  onDismiss?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onDismiss }) => {
  if (!error) return null;

  return (
    <div className="flex items-center justify-between p-4 bg-red-50 border border-red-200 rounded-lg mx-4 mb-4">
      <p className="text-red-800 text-sm flex-1">
        {error || "Oops, it looks like our AI had a bit of a hiccup and broke the app"}
      </p>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-4 text-red-600 hover:text-red-800 text-sm font-medium"
        >
          Dismiss
        </button>
      )}
    </div>
  );
}; 